import en from './en.json';
import bs from './bs.json';
import hr from './hr.json';

const translations = { en, bs, hr };
const loadTranslations = (lang) => {
  return translations[lang];
};

export {
  loadTranslations,
  en,
  bs,
  hr,
};
